<template>
  <v-btn
    v-if='!password'
    @click="retrieve"
    :loading="loading"
    text
  >
    <v-icon size="25" color="red dark-2">mdi-lock</v-icon>
    Retrieve Password
  </v-btn>
  <v-btn v-else
    @click="clipboard"
    text
  >
    <v-icon size="25" color="green dark-2">mdi-clipboard-outline</v-icon>
    Copy Password to Clipboard
  </v-btn>
</template>
<script>
export default {
  props: {
    client: { required: true },
  },
  data: () => (
    {
      loading: false,
      password: false
    }
  ),
  methods: {
    retrieve() {
        this.loading = true;
        this.$http.get(`api/v1/infra/aws/${this.client.id}/secrets_manager`)
          .then((response) => {
            this.password = response.password
            window.Notify.success('Retireved password');
          })
          .catch(error => {
            this.showResponseError(error);
          })
          .finally(() => (this.loading = false));
    },
    clipboard() {
      navigator.clipboard.writeText(this.password);
      window.Notify.success('Copied to clipboard.');
      this.password = null
    }
  },
};
</script>
